import React from 'react'
import styled from 'styled-components'
import lolgif from '../lolgif.gif'
// import { Link } from "react-router-dom"

export default function Home() {
  return (
    <Container>  
      <Image src={lolgif} alt="Funny GIF" />  

    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  gap: 1.5rem;
  min-height: 100vh; /* centers vertically */
  box-sizing: border-box;
`

const Image = styled.img`
  width: 100%;
  max-width: 1200px; /* prevents it from being *too* big on huge screens */
  height: auto;
  object-fit: cover;
  border-radius: 12px;

  @media (max-width: 768px) {
    max-width: 90%;
  }

  @media (max-width: 480px) {
    max-width: 100%;
  }
`

// const Text = styled.p`
//   font-size: 1.2rem;
//   text-align: center;
// `

// const StyledLink = styled(Link)`
//   color: #ffffff;
//   text-decoration: none;
//   margin-left: 0.3rem;

//   &:hover {
//     text-decoration: underline;
//   }
// `
